import { FC, CSSProperties, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
   order?: number;
   grow?: number;
   shrink?: number;
   basis?: string | number;
   overflow?: CSSProperties['overflow'];
   overflowX?: CSSProperties['overflowX'];
   overflowY?: CSSProperties['overflowY'];
}

export const BoxItem: FC<Props> = ({ order = 0, grow = 0, shrink = 1, basis, overflow, overflowX, overflowY, children }) => (
   <div
      data-testid="box-item"
      style={{
         order,
         flexGrow: grow,
         flexShrink: shrink,
         flexBasis: basis,
         overflow,
         overflowX,
         overflowY
      }}
   >
      {children}
   </div>
);
